import { LinkTabGeneric } from '@mentimeter/next-navigation';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Tooltip } from '@mentimeter/ragnar-ui/tooltip';
import { VIEW_ONLY_DISABLED_MESSAGE } from '@mentimeter/editor-essentials/constants';
import type { TabAction } from './TabAction';

export const HeaderTab = ({
  action,
  activeTab,
}: {
  action: TabAction;
  activeTab: string;
}) => {
  const badgeValueIsZero = action.badgeValue === 0;
  return (
    <Tooltip
      trigger={
        <LinkTabGeneric
          extend={() => ({
            pointerEvents: 'auto',
          })}
          id={action.key}
          key={action.key}
          active={action.key === activeTab}
          aria-label={action.title}
          aria-selected={action.key === activeTab}
          onClick={action.onClick}
          justifyContent="center"
          height="100%"
          href={action.href}
          prefetch
          disabled={action.viewOnly}
        >
          <Box flexDirection="row" alignItems="center">
            <Text
              color={action.viewOnly ? 'textDisabled' : 'text'}
              fontWeight="semiBold"
              lineHeight="125"
              fontSize="87.5"
              truncate
            >
              {action.title}
            </Text>
            {action.badgeValue !== undefined && (
              <Box
                bg={badgeValueIsZero ? 'neutralWeak' : 'secondaryWeak'}
                borderRadius="2xl"
                px="space2"
                alignItems="center"
                justifyContent="center"
                height="20px"
                ml="space2"
              >
                <Text
                  variant="ragnarLabelSm"
                  color={badgeValueIsZero ? 'textWeaker' : 'onNeutralWeak'}
                  lineHeight="125"
                  fontSize="87.5"
                >
                  {action.badgeValue}
                </Text>
              </Box>
            )}
          </Box>
        </LinkTabGeneric>
      }
      side="bottom"
    >
      {action.viewOnly && VIEW_ONLY_DISABLED_MESSAGE}
    </Tooltip>
  );
};
